import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  IListScheduledValuesFetchParams,
  IScheduledValue,
  MN_SCHEDULED_VALUES,
} from '@jobcost-monorepo/crud';

export default function ScheduledValuesPage() {
  return (
    <Grid<IScheduledValue, IListScheduledValuesFetchParams>
      moduleName={MN_SCHEDULED_VALUES}
      updateStore={false}
    />
  );
}
